import React from "react";

const Error = () => {
  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        color: "red",
        marginTop: 50
      }}
    >
      <center>
        <h5>Estimado Usuario se ha producido un error.</h5>
      </center>
    </div>
  );
};

export default Error;
